import { useEffect, useRef, useCallback } from 'react';
import { useGameState, useGameDispatch } from '../GameProvider';
import { setShowdownStep } from '../gameActions';
import gameService from '../gameService';

export default function ShowdownScreen() {
  const state = useGameState();
  const dispatch = useGameDispatch();
  const { gameId, gameMode, phase, showdownStep } = state;
  const timerRef = useRef(null);

  const isChi = gameMode === 'chi' || gameMode === 'nemchi';
  const isDealer = state.uid === state.dealerUid;

  const advanceStep = useCallback(() => {
    if (!isChi) {
      // Non-chi: go straight to results after brief pause
      if (isDealer) {
        setTimeout(() => gameService.transitionToResults(gameId), 2000);
      }
      return;
    }

    // Chi: step through rows
    if (showdownStep < 2) {
      timerRef.current = setTimeout(() => {
        dispatch(setShowdownStep(showdownStep + 1));
      }, 3500);
    } else {
      // All rows revealed — transition to results
      if (isDealer) {
        timerRef.current = setTimeout(() => {
          gameService.transitionToResults(gameId);
        }, 2000);
      }
    }
  }, [isChi, showdownStep, isDealer, gameId, dispatch]);

  useEffect(() => {
    if (phase !== 'showdown') return;
    advanceStep();
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [phase, showdownStep, advanceStep]);

  // This component has no visual output — the PokerTable handles rendering
  // based on showdownStep and revealedArrangements from state
  return null;
}
